import * as React from 'react'
import { ITabMenu } from '../../models'
import MenuCard from './MenuCard'
import MenuLinkList from './MenuLinkList'

export function SubNavigationDesk({ tabs }: { tabs: ITabMenu[] }) {
  const [menuTabSelected, setMenuTabSelected] = React.useState<ITabMenu | null>(
    tabs[0]
  )

  const onHandleMenuTab = (
    event: React.MouseEvent<HTMLLIElement, MouseEvent>,
    tab: ITabMenu
  ) => {
    event.preventDefault()
    setMenuTabSelected(tab)
  }
  return (
    <div className="grid grid-cols-[auto,1fr] gap-6 xl:gap-[30px]">
      <div className="  md:w-[220px]">
        <ul className="flex flex-col items-start gap-[20px] shrink-0 pt-[10px]">
          {tabs.map((tab) => (
            <li
              className={` text-sm cursor-pointer decoration-solid   `}
              onClick={(e) => onHandleMenuTab(e, tab)}
            >
              <div>
                <span
                  className={`text-balance underline link-chevron-right-span  decoration-solid  decoration-[3px]   underline-offset-[8px] hover:decoration-visionary-green-1 leading-[2] ${
                    menuTabSelected?.LinkLabel === tab.LinkLabel
                      ? 'decoration-engineering-grey-1'
                      : 'decoration-white'
                  }`}
                >
                  {tab.LinkLabel}
                </span>
              </div>
            </li>
          ))}
        </ul>
      </div>
      <div className="flex flex-row gap-6 xl:gap-[30px]">
        {menuTabSelected &&
          menuTabSelected.Items.map((item) => {
            if ('Heading' in item) {
              return (
                <MenuCard
                  heading={item.Heading}
                  text={item.Teaser}
                  imageUrl={item.ImageUrl}
                  link={item.Link}
                  key={item.Heading}
                  linkText={false}
                />
              )
            }
            if ('LinkList' in item && item.LinkList?.length > 0) {
              return (
                <div className="w-max">
                  <MenuLinkList subLinks={item.LinkList} />
                </div>
              )
            }
          })}
      </div>
    </div>
  )
}

export default SubNavigationDesk
